<template>
    <div>
        <h1 class="title is-3 between-center">
            <span>{{ type | ucfirst }} Work Types</span>
            <div class="field is-grouped">
                <p v-if="checkedRows.length" class="control">
                    <a @click.prevent="confirmCustomDelete" class="button is-danger"><span>Delete selected</span></a>
                </p>
                <p class="control">
                    <button @click="handleCreate" class="button is-info" ><span class="icon"><i class="icm-new"></i></span><span>New</span></button>
                </p>
            </div>
        </h1>
        <div class="columns">
            <div class="column">
                <o-table
                    v-bind="table"
                    :data="items"
                    :selected.sync="selected"
                    :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event"
                    default-sort="user.first_name"
                >
                    <template slot-scope="props">
                        <o-table-column field="jobType" label="Job Type" sortable>
                            {{ props.row.title }}
                        </o-table-column>

                        <o-table-column field="price" label="Price" sortable>
                            {{ props.row.price | currency }}
                        </o-table-column>

                        <o-table-column field="status" label="Status" width="40">
                            {{ props.row.is_active ? 'Active' : 'Inactive' }}
                        </o-table-column>

                        <o-table-column label="">
                            <o-dropdown hoverable position="bottom-left" class="table-actions">
                                <button class="button" slot="trigger">
                                    <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                                </button>
                                <o-dropdown-item has-link><a @click.stop.prevent="handleEdit(props.row)" class="button is-warning is-small">Edit</a></o-dropdown-item>
                            </o-dropdown>
                        </o-table-column>
                    </template>

                    <div slot="empty" class="has-text-centered">
                        This table is empty!
                    </div>
                </o-table>
            </div>
        </div>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="editModalActive">
            <work-type-modal :item="editItem" />
        </o-modal>
    </div>
</template>
<script>
    import {mapGetters, mapActions} from 'vuex'
    import Table from './../../mixins/Table'
    import WorkTypeModal from '../../components/modals/WorkType'

    export default {
        mixins: [Table],

        components: {
            WorkTypeModal,
        },

        computed: {
            ...mapGetters(['workTypesByType']),

            type() {
                return this.$route.meta.type
            },

            items() {
                return this.workTypesByType(this.type)
            }
        },

        data() {
            return {
                editModalActive: false,
                editItem: {}
            }
        },

        methods: {
            ...mapActions({
                fetchWorkTypes: 'fetchWorkTypes',
                removeItem: 'removeWorkType'
            }),

            handleCreate() {
                this.editItem = {
                    type: this.type,
                    is_active: true
                }
                this.editModalActive = true
            },

            handleEdit(item) {
                this.editItem = item
                this.editModalActive = true
            }
        }
    }
</script>
